import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { bootstrapTestUser } from './testUser';

// Seed the store before the first render, so the redirect guards on protected
// routes see the test user instead of bouncing to "/". See src/testUser.js.
const testUser = bootstrapTestUser();
if (testUser) window.__UserData__ = testUser;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
